import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const ReminderContactAdd = lazyLoader(
  () =>
    import(
      "Containers/ReminderContact/ReminderContactCreate/ReminderContactCreate"
    )
);

export const ReminderContactAddPage = () => {
  return (
    <Layout>
      <ReminderContactAdd />
    </Layout>
  );
};
